export default {
  EXEMPTIBLE_UNITS: "exemptions/exemptible",
  EXEMPTIONS: "exemptions",
  getExemption: (id) => `exemptions/exemption/${id}`,
  patchExemption: "exemptions/exemptpatch",
  resubmit: "exemptions/resubmit",
  deleteExemption: "exemptions/deleteExemption",
  deleteLine: "exemptions/deleteLine",
  deleteAttachment: "exemptions/deleteAttachment",
  proforma: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_getRequestProFormaInvoice?requestNo=${id}`,
  receipt: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_getReceiptReport?receiptNo=${id}`,
  EXEMPTION_LETTER: (exemptionNumber) =>
    `cu/PEGASUS_CU/SchoolManagement_getExemptionLetter?applicationNo=${exemptionNumber}`,
  gradeSetup: "setup/exemptionGrade",
  ACKNOWLEDGEMENT_LETTER: (id) =>
    `cu/PEGASUS_CU/SchoolManagement_getExemptionAcknowledgementLetter?applicationNo=${id}`,
  ACCREDITEDINSTITUTE: "setup/accreditedInstitute",
  AWARDINGBODIES: "setup/awardingBodies",
  EDUCATION_LEVELS: "setup/levels",
};
